export default __webpack_public_path__ + "static/media/Strech-Yarn-Digital.1d4b8635.pdf";